import { Model } from '@hub-components';

export class Audit extends Model {
  public auditableId: number;
  public auditableType: string;
  public associatedId: number;
  public associatedType: string;
  public username: string;
  public userEmail: string;
  public userName: string;
  public action: string;
  public auditedChanges: any;
  public comment: string;
  public createdAt: Date;
  public parentRecord: any;
  public record: any;
  public diffs: string;

  constructor(obj) {
    super(obj);
    if (obj.created_at) {
      this.createdAt = new Date(obj.created_at);
    }
  }
}
